import React from 'react';
import CTA from '../../../../components/cta/CTA';
import { FaStar } from 'react-icons/fa6';
import { FaCheck } from 'react-icons/fa';
import NavBar from '../../../../components/navbar/navbar';
import Footer from '../../../../components/footer/footer';
import { useNavigate } from 'react-router-dom';

function Level() {

  const navigate = useNavigate()

  const Levels = [
    {
      head: "Level 1",
      level: "Level 1",
      features: [
        "5 completed orders",
        "3 unique clients",
        "300$+ earnings",
        "75% response rate",
        "minium 4.4 rating"
      ],
      Benefits: [
        "Level 1 Badge (Badge appears at the Profile of the user)",
        "Boosted Profile (User is able to boost his profile / advertising)"
      ]
    },
    {
      head: "Level 2",
      level: "Level 2",
      features: [
        "15 completed orders",
        "8 unique clients",
        "1500$+ earnings",
        "80% response rate",
        "minium 4.6+ rating"
      ],
      Benefits: [
        "Level 2 Badge",
        "Boosted Profile (user is able to boost his profile / advertising)",
        "Early Payout: Skip the clearing period and get paid immediately (fee applies)",
        "Faster Payments: Earnings clear in 9 days instead of 12 days"
      ]
    },
    {
      head: "Level 3",
      level: "Top Rated",
      features: [
        "30 completed orders",
        "15 unique clients",
        "7,500$+ earnings",
        "90% response rate",
        "minium 4.7+ rating"
      ],
      Benefits: [
        "Top Rated Badge",
        "Early Payout",
        "Skip the clearing period and get paid immediately (fee applies)",
        "Faster Payments: Earnings clear in 7 days instead of 12 days",
        "Priority customer support: Get faster responses to your Help Center Tickets"
      ]
    }
  ]

  return (
    <>
      <NavBar />
      <div className='bg-[#fafafa]'>
        <div className="xl:min-h-screen relative">
          <div className='bg-white absolute -z-0 w-[100%] h-[90%] md:h-[70%]'>
          </div>
          <div className='flex flex-col items-center gap-2 md:gap-4 py-8 md:py-16 px-4 sm:px-8 lg:px-16 relative z-10'>
            <h1 className="text-2xl font-pop text-[#868686] lg:text-3xl font-normal my-4 text-center">LEVELS</h1>
            <h1 className='text-4xl md:text-5xl font-pop font-semibold text-center'>New pathways for <span className='italic text-primarygreen'>success </span></h1>
            <p className='text-center font-pop text-base max-w-[100%] md:max-w-[80%] xl:max-w-[60%] md:m-auto my-4'>Get to know our new system and platform updates designed to help guide your journey on Paycott, providing clarity and certainty every step of the way.</p>
            <button 
              className='bg-primarygreen text-white font-pop rounded-full my-6 py-3 px-8 border-2 border-primarygreen text-lg hover:bg-transparent hover:text-primarygreen ease-in-out duration-300'
              onClick={()=>{
                navigate('/signup')
              }}
            >Get Started</button>
          </div>
          <div
            className='flex flex-row gap-4 md:gap-8 items-center py-10 md:py-20 lg:rounded-2xl px-1 md:px-10 w-[100%]  lg:w-[80%] m-auto relative z-10'
            style={{ background: "url(../Assets/Banner/level.png)", backgroundRepeat: "no-repeat", backgroundSize: "100% 100%", backgroundPosition: "center" }}
          >
            <div className="flex flex-col justify-center items-center gap-4 md:gap-6 basis-[50%]">
              <div className='flex flex-row gap-2 bg-[#39e23d] rounded-full py-2 px-4 items-center'>
                <h2 className='text-white font-bold text-base md:text-2xl'>Level 1</h2>
                <FaStar className='text-white text-xl md:text-3xl' />
              </div>
              <div className='flex flex-row gap-2 bg-[#0070aa] rounded-full py-2 px-4 items-center'>
                <h2 className='text-white font-bold text-base md:text-3xl'>Level 2</h2>
                <div className='text-white flex flex-row text-xl md:text-4xl'>
                  <FaStar />
                  <FaStar />
                </div>
              </div>
              <div className='flex flex-row gap-2 bg-[#ff6c00] rounded-full py-2 px-2 md:px-4 items-center'>
                <h2 className='text-white font-bold text-base md:text-4xl'>Top Rated</h2>
                <div className='text-white flex flex-row text-xl md:text-4xl'>
                  <FaStar />
                  <FaStar />
                  <FaStar />
                </div>
              </div>
            </div>
            <div className="flex flex-col gap-2 md:gap-4 basis-[50%]">
              <h1 className='text-base md:text-2xl font-pop font-semibold text-white'>New pathways for <span className='italic text-primarygreen'>success </span></h1>
              <p className='text-white font-pop text-xs md:text-base md:m-auto my-1 md:my-4'>Get to know our new system and platform updates designed to help guide your journey on Paycott, providing clarity and certainty every step of the way.</p>
            </div>
          </div>
        </div>
        <div className="m-auto w-[90%] xl:w-[80%] py-10">
          <h2 className='text-4xl font-medium font-pop text-center'>Get to know levels</h2>
          <div className="flex flex-col lg:flex-row gap-6 py-10">
            {Levels.map((item, index) => (
              <div className="bg-white rounded-xl border-2 border-light py-12 px-10 flex flex-col gap-4 basis-[33.33%] h-[100%]">
                <h2 className='text-xl font-bold font-pop'>{item.head}</h2>
                <div className={`flex flex-row gap-2 ${index == 0 ? 'bg-[#39e23d]' : index == 1 ? 'bg-[#0070aa]' : 'bg-[#ff6c00]'} rounded-full py-2 px-4 w-fit`}>
                  <h2 className='text-white font-bold text-xl'>{item.level}</h2>
                  <div className='text-white flex flex-row text-2xl'>
                    {index == 0 ? (
                      <FaStar />
                    ) : index == 1 ? (
                      <>
                        <FaStar />
                        <FaStar />
                      </>
                    ) : (
                      <>
                        <FaStar />
                        <FaStar />
                        <FaStar />
                      </>
                    )}
                  </div>
                </div>
                <div className="flex flex-col gap-2">
                  {item?.features?.map((item2, index2) => (
                    <div className="flex flex-row gap-2 font-pop text-base text-lightGrey">
                      <FaCheck className='text-lg text-[#63D577]' />
                      <p>{item2}</p>
                    </div>
                  ))}
                </div>
                <h2 className='text-lg font-pop font-medium'>Benefits</h2>
                <div className="flex flex-col gap-2">
                  {item?.Benefits?.map((item2, index2) => (
                    <div className="flex flex-row gap-2 font-pop text-lightGrey">
                      <FaCheck className='text-lg text-[#63D577]' />
                      <p className='text-base'>{item2}</p>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
        <CTA />
      </div>
      <Footer/>
    </>
  );
}

export default Level;
